import React from "react";
import { GlitterSparkles } from "./GlitterSparkles";
type RefundPolicyPageProps = {
  onBack: () => void;
  onContact: () => void;
};
export function RefundPolicyPage({
  onBack,
  onContact
}: RefundPolicyPageProps) {
  return <main className="relative min-h-[100dvh] w-full bg-[#10070f] px-4 py-10 text-white sm:px-8 sm:py-14" data-id="element-262" data-mp="32y21lx7q3pbq">
      <div className="pointer-events-none fixed inset-0" aria-hidden="true" data-id="element-263" data-mp="37wc1gl4e7e3o">
        <GlitterSparkles count={350} data-id="element-264" data-mp="2tx3wfbljtbrk" />
      </div>
      <div className="relative mx-auto max-w-3xl" data-id="element-265" data-mp="2u0i14qhopx26">
        <button type="button" onClick={onBack} className="mb-8 text-sm font-medium text-[#35dceb] underline decoration-transparent underline-offset-4 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#35dceb]" data-id="element-266" data-mp="2yy01hshmz3yk">
          Back to home
        </button>

        <header className="border-b border-[#ff3aa2]/60 pb-6" data-id="element-267" data-mp="n6ecgnyyb13h">
          <h1 className="text-3xl font-semibold tracking-tight text-[#ff5bad] sm:text-4xl" data-id="element-268" data-mp="1efczwyepz4hr">Pickens Passions Refund Policy</h1>
          <p className="mt-2 text-sm text-white/70" data-id="element-269" data-mp="19frymhc2uk1v">Effective Date: October 2, 2026</p>
        </header>

        <p className="mt-6 text-sm leading-6 text-white/80" data-id="element-270" data-mp="1o4egoqt39pws">
          Thank you for shopping with Pickens Passions! Every rhinestone creation, embellished tumbler, personalized item, and DIY rhinestone kit is made with care. This Refund Policy explains how refunds work for custom and personalized orders.
        </p>

        <div className="mt-8 space-y-8" data-id="element-271" data-mp="qjs4azvmn4f4">
          <section aria-label="Custom and Personalized Orders" data-id="element-272" data-mp="14hgoe5hve7j4">
            <h2 className="text-lg font-semibold text-[#35dceb]" data-id="element-273" data-mp="14fm6l01wavj9">1. Custom and Personalized Orders Are Final Sale</h2>
            <div className="mt-2 space-y-3" data-id="element-274" data-mp="2fwvnpfxjxbhe">
              <p className="text-sm leading-6 text-white/80" data-id="element-275" data-mp="2fvkjxg43w3qa">
                Because custom designs and personalized orders are made specifically for you, they are final sale. We are unable to offer refunds for a change of mind.
              </p>
              <p className="text-sm leading-6 text-white/80" data-id="element-276" data-mp="18mqyifd08roa">
                Refunds are also not available for personalization details you have approved, including names, spelling, dates, colors, sizes, and design choices. Please review every detail carefully before approving your order.
              </p>
            </div>
          </section>

          <section aria-label="Your Legal Rights" data-id="element-277" data-mp="puy1m9utemba">
            <h2 className="text-lg font-semibold text-[#35dceb]" data-id="element-278" data-mp="ps26sue9kdr2">2. Your Legal Rights</h2>
            <div className="mt-2 space-y-3" data-id="element-279" data-mp="uqlrkrh4fjhu">
              <p className="text-sm leading-6 text-white/80" data-id="element-280" data-mp="yubb32ixvaw0">
                Our final sale policy does not remove any rights you have under applicable law. If an item is defective, arrives damaged, or differs materially from the order we agreed on, you keep the remedies available to you by law.
              </p>
            </div>
          </section>

          <section aria-label="Order Concerns" data-id="element-281" data-mp="b2mg1eeqg8bd">
            <h2 className="text-lg font-semibold text-[#35dceb]" data-id="element-282" data-mp="3ketso0iomke">3. Order Concerns</h2>
            <div className="mt-2 space-y-3" data-id="element-283" data-mp="3ur94zeoxr7f7">
              <p className="text-sm leading-6 text-white/80" data-id="element-284" data-mp="3usk8reidsf6b">
                If you have a concern about your order, please reach out through our{" "}
                <button type="button" onClick={onContact} className="text-[#35dceb] underline underline-offset-2 transition-colors duration-150 ease-out hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" data-id="element-285" data-mp="3lrvwao8mymvj">
                  Contact page
                </button>
                .
              </p>
            </div>
          </section>
        </div>
      </div>
    </main>;
}